import request from "@/utils/request";

/**
 * 发送验证码
 * @param {object} data - 请求参数，包含 phone 或 email
 * @returns {Promise}
 */
export function sendVerificationCode(data) {
  return request({
    url: "/api/v1/users/send_verification_code",
    method: "post",
    data,
  });
}

/**
 * 用户注册
 * @param {object} data - 注册表单数据
 * @returns {Promise}
 */
export function registerUser(data) {
  return request({
    url: "/api/v1/users/register",
    method: "post",
    data,
  });
}

/**
 * 重置密码
 * @param {object} data - 重置表单数据
 * @returns {Promise}
 */
export function resetPassword(data) {
  return request({
    url: "/api/v1/users/reset_password",
    method: "post",
    data,
  });
}

/**
 * 用户登录
 * @param {object} data - 登录凭证 (phone/email 和 password)
 * @returns {Promise}
 */
export function loginUser(data) {
  return request({
    url: "/api/v1/users/login",
    method: "post",
    data,
  });
}

/**
 * 获取未读消息数量
 * @returns {Promise}
 */
export function getUnreadMessageCount() {
  return request({
    url: "/api/v1/notify/user-messages/unread_count",
    method: "get",
    showLoading: false,
  });
}

/**
 * 获取当前登录用户信息
 * @returns {Promise}
 */
export function getUserInfo() {
  return request({
    url: "/api/v1/users/me",
    method: "get",
    showLoading: false,
  });
}

/**
 * [新增] 获取当前用户的消息列表
 * @param {object} params - 查询参数，例如 { is_read: boolean }
 * @returns {Promise}
 */
export function getUserMessages(params) {
  return request({
    url: "/api/v1/notify/user-messages",
    method: "get",
    params, // GET 请求的查询参数会附加到 URL 上
    showLoading: false,
  });
}

/**
 * [新增] 根据ID获取单条消息详情
 * @param {number} id - 消息的ID
 * @returns {Promise}
 */
export function getMessageDetail(id) {
  return request({
    url: `/api/v1/notify/user-messages/${id}`, // 使用模板字符串动态传入ID
    method: "get",
    showLoading: false,
  });
}
